export const isSavedVersionOutdated = (
  savedVersion: string,
  backendVersion: string,
): boolean => {
  const parseVersion = (version: string): number[] =>
    version.split('.').map((part) => parseInt(part, 10));

  const savedParts = parseVersion(savedVersion);
  const backendParts = parseVersion(backendVersion);

  for (let i = 0; i < Math.max(savedParts.length, backendParts.length); i++) {
    const saved = savedParts[i] || 0;
    const backend = backendParts[i] || 0;

    if (saved < backend) return true;
    if (saved > backend) return false;
  }

  return false;
};

export const isShowVersionBadge = (
  badgeVersion: string,
  version: string,
): boolean => {
  const parseVersion = (version: string): number[] =>
    version
      .split('.')
      .slice(0, 2)
      .map((part) => parseInt(part, 10));

  const badgeParts = parseVersion(badgeVersion);
  const versionParts = parseVersion(version);

  for (let i = 0; i < Math.max(badgeParts.length, versionParts.length); i++) {
    const badge = badgeParts[i] || 0;
    const version = versionParts[i] || 0;

    if (badge < version) return false;
    if (badge > version) return true;
  }

  return true;
};
